export const Types = {
  GET_ACCOUNT_LIST: "GET_ACCOUNT_LIST",
  OPEN_ADD_ACCOUNT_MODAL: "OPEN_ADD_ACCOUNT_MODAL",
  ADD_ACCOUNT: "ADD_ACCOUNT",
  GET_EDIT_ACCOUNT: "GET_EDIT_ACCOUNT",
  LOAD_VIEW_DASHBOARD: "LOAD_VIEW_DASHBOARD",
};
